<template>
  <div></div>
</template>

<script lang="ts" setup>
import { LoginModal } from "#components";

definePageMeta({
  layout: "blank",
});

const overlay = useOverlay();
const modal = overlay.create(LoginModal);

const toast = useToast();

const redirectCookie = useCookie<string>("redirectUrl");
const target = computed(() => {
  // Prefer query param if you later switch to passing ?redirect=
  const route = useRoute();
  return (route.query.redirect as string) || redirectCookie.value || "/";
});

function openLoginModal() {
  modal.open({
    onSuccess() {
      modal.close();
      toast.add({
        title: "Login successful !",
        id: "modal-success",
        color: "success",
      });
      redirectCookie.value = "";
      navigateTo(target.value);
    },
    onClose() {
      modal.close();
    },
  });
}

onMounted(() => {
  openLoginModal();
});
</script>

<style></style>
